import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Empty,
  Divider,
  InputNumber,
  Input,
} from "antd";
import styled from "styled-components";
import ProductCard from "../productCard";
import { useHistory } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";
import { BsChevronRight } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import CustomModal from "../modals/customModal";
import LoaderGif from "../../assets/images/ie_loader.gif";

import Delete_order from "../../assets/images/delete_order.png";
import Configuration from "../../assets/images/configuration.png";
const CatalogCardWrapper = styled(Card)`
  min-height: 350px;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  margin-top: 30px;

  .table-filters {
    height: 2rem;
    text-align: center;
    border-color: #9e9e9e;
    border-radius: 0px;
    font-size: 14px;
    width: auto;
  }
  .table-filters-heading {
    font-size: 0.8rem;
    color: #000;
    padding-right: 16px;
  }
`;
const productData = [];
function CatalogCard({
  products,
  categoryName,
  onChangeFilter,
  onChangeShowingFilter,
  previousPage,
  currentPage,
  metaData,
  updateProductPrice,
  onUpdateProductPrice,
  onOpenModal,
  value,
  updateProduct,
  fromNewCatalog,
  NewCatalogInput,
  postProduct,
  isLoading,
  callOnCallBack,
  isProductLoading,
  dividerShow,
  iscardTrue,
  onAdd,
}) {
  const history = useHistory();
  let [isOpenModal, setIsOpenModal] = useState(false);
  const [productId, setProductId] = useState("");
  const [configModal, setConfigModal] = useState(false);
  const [product, setProduct] = useState({})
  const [priceError, setPriceError] = useState("")
  const [currentIndex, setIndex] = useState(0);
  const [editedProduct, setEditedProduct] = useState([])
  const [editedIndex, setEditIndex] = useState(0)
  const [additiveErr, setAdditiveErr] = useState([])

  useEffect(() => {
    setEditedProduct(products)
  }, [products])
  const onUpdateRmxPrice = (e, index) => {
    const arr = { ...product };
    arr.rmx_product_additives[index].price = e;
    additiveErr[index] = null
    setAdditiveErr(additiveErr)


    setProduct(arr);
    setPriceError(true)
  };
  const onChangeOnAdd = (e, index, name) => {
    const arr = { ...product };
    arr.product_additives[index] = {
      name,
      description: "",
      price: e,
    };
    additiveErr[index] = null
    setAdditiveErr(additiveErr)
    setProduct(arr);
    setPriceError("")
  };

  const onAddProduct = () => {
    const arr = [];
    (product.product_additives || []).forEach((v, index) => {
      if (!v.price) {
        arr[index] = 'error'
      }

    })
    setAdditiveErr(arr)
    const errorCheck = arr.some((item) => {
      return item === "error"
    })

    if (product.price) {
      if (errorCheck) {
        return
      }
      productData.push({ ...product, isSave: true });
      setConfigModal(false);
      if (onAdd) {
        onAdd(productData);
      }

    } else {
      setPriceError("Price is required.")

    }



  };
  const updatePriceOfProd = (e) => {
    const arr = { ...product };
    const abc = [...editedProduct]
    abc[editedIndex]['price'] = e
    setEditedProduct(abc)
    arr.price = e;
    setProduct(arr);
  };

  return (
    <Row>
      <Col span={24} style={{ paddingLeft: "13px" }}>
        {iscardTrue ? (
          <>
            <Row
              justify="space-between"
              style={{
                borderBottom: dividerShow && "1px solid lightgrey",
              }}
            >
              <Col xl={12} xs={24} sm={24} md={12}>
                <h5 className="text-left" style={{ paddingLeft: "12px" }}>
                  {categoryName}
                </h5>
              </Col>
              <Col xl={12} xs={24} sm={24} md={12}>
                {!fromNewCatalog && (
                  <h2
                    className="text-right pointer-cursor"
                    onClick={() => history.push("/catalog/new")}
                  >
                    <AiOutlinePlus size={20} className="pointer-cursor" />
                  </h2>
                )}
              </Col>
            </Row>
            <Row
              justify="space-between"
              style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}
            >
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#9e9e9e",
                    paddingRight: "10px",
                  }}
                >
                  Sort by
                </span>
                <select
                  style={{
                    height: "2rem",
                    textAlign: "center",
                    borderColor: "#9e9e9e",
                    borderRadius: "0px",
                    fontSize: "14px",
                    width: "auto",
                  }}
                  onChange={(e) => onChangeFilter(e.target.value)}
                >
                  <option>Price</option>
                  <option>Name</option>
                </select>
              </Col>
              <Col
                xl={4}
                lg={4}
                md={4}
                sm={7}
                xs={7}
                style={{
                  paddingLeft: "11px",
                }}
              >
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#9e9e9e",
                    paddingRight: "10px",
                  }}
                >
                  Showing
                </span>
                <select
                  style={{
                    height: "2rem",
                    textAlign: "center",
                    borderColor: "#9e9e9e",
                    borderRadius: "0px",
                    fontSize: "14px",
                    width: "auto",
                  }}
                  onChange={(e) => onChangeShowingFilter(e.target.value)}
                >
                  <option>12</option>
                  <option>24</option>
                  <option>48</option>
                  <option>96</option>
                </select>
              </Col>
            </Row>
            <Row>
              {products.length ? (
                products.map((item, index) => {
                  return (
                    <Col xl={8} lg={8} md={6} xs={24} sm={24}>
                      <ProductCard
                        fromNewCatalog={fromNewCatalog}
                        data={item}
                        onAdd={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                          setIndex(index);
                          setPriceError("")
                        }}
                        onConfigure={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                          setPriceError("")
                        }}
                        onDeactive={(e) => {
                          setIsOpenModal(true);
                          setProductId(item.id);
                          setProduct(item);
                        }}
                        productData={productData}
                      />
                    </Col>
                  );
                })
              ) : (
                <Col span={24}>
                  {isLoading && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                  {!isLoading && (
                    <Empty description={"Nothing to show right now."} />
                  )}
                </Col>
              )}
            </Row>
            {products.length !== 0 && (
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Row
                  gutter={[5, 0]}
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  justify="start"
                >
                  <Col className="tablePagination">
                    {console.log("MetaData===>", product)}
                    {`Displaying ${metaData?.currentCount} of ${metaData?.totalCount}`}
                    <Button
                      type="link"
                      icon={<BsChevronLeft color="#686868" size={15} />}
                      onClick={previousPage}
                      disabled={metaData.page === 1}
                    />
                    {metaData?.page}
                    <Button
                      type="link"
                      icon={<BsChevronRight color="#686868" size={15} />}
                      onClick={currentPage}
                      disabled={metaData.total_pages === metaData.page}
                    />
                  </Col>
                </Row>
              </Col>
            )}
          </>
        ) : (
          <CatalogCardWrapper>
            <Row
              justify="space-between"
              style={{
                borderBottom: dividerShow && "1px solid lightgrey",
                marginBottom: '15px',
              }}
            >
              <Col span={12} xl={12} xs={24} sm={24} style={{ marginBottom: '7px' }}>
                <h5 className="text-left">{categoryName}</h5>
              </Col>
              <Col span={12} xl={12} xs={24} sm={24}>
                {!fromNewCatalog && (
                  <h2
                    className="text-right pointer-cursor"
                    onClick={() => history.push("/catalog/new")}
                  >
                    <AiOutlinePlus size={20} className="pointer-cursor" />
                  </h2>
                )}
              </Col>
            </Row>
            <Row justify="space-between" style={{ padding: "1rem 0rem 0.2rem" }}>
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span className="table-filters-heading">Sort by</span>
                <select
                  className="table-filters"
                  onChange={(e) => onChangeFilter(e.target.value)}
                >
                  <option>Price</option>
                  <option>Name</option>
                </select>
              </Col>
              <Col xl={4} lg={4} md={4} sm={7} xs={7}>
                <span className="table-filters-heading">Showing</span>
                <select
                  className="table-filters"
                  onChange={(e) => onChangeShowingFilter(e.target.value)}
                >
                  <option>12</option>
                  <option>24</option>
                  <option>48</option>
                  <option>96</option>
                </select>
              </Col>
            </Row>
            <Row>
              {editedProduct.length ? (
                editedProduct.map((item, i) => {
                  return (
                    <Col xl={8} lg={8} md={9} xs={24} sm={24}>
                      <ProductCard
                        fromNewCatalog={fromNewCatalog}
                        data={item}
                        onAdd={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct({ ...item });
                          onOpenModal(item.price);
                          setEditIndex(i)
                          setPriceError("")
                          setAdditiveErr([])
                        }}
                        onConfigure={(e) => {
                          setConfigModal(true);
                          setProductId(item.id);
                          setProduct(item);
                          onOpenModal(item.price);
                          setPriceError("")
                          setAdditiveErr([])
                        }}
                        onDeactive={(e) => {
                          setIsOpenModal(true);
                          setProductId(item.id);
                          setProduct(item);
                        }}
                        productData={productData}
                      />
                    </Col>
                  );
                })
              ) : (
                <Col span={24}>
                  {isLoading && (
                    <img src={LoaderGif} height={"60"} width={"60"} />
                  )}
                  {!isLoading && (
                    <Empty description={"Nothing to show right now."} />
                  )}
                </Col>
              )}
            </Row>
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <Row
                gutter={[5, 0]}
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                justify="end"
              >
                <Col className="tablePagination">
                  {`Displaying ${metaData?.currentCount} of ${metaData?.totalCount}`}
                  <Button
                    type="link"
                    icon={<BsChevronLeft color="#686868" size={15} />}
                    onClick={previousPage}
                    disabled={metaData.page === 1}
                  />
                  {metaData?.page}
                  <Button
                    type="link"
                    icon={<BsChevronRight color="#686868" size={15} />}
                    onClick={currentPage}
                    disabled={metaData.total_pages === metaData.page}
                  />
                </Col>
              </Row>
            </Col>
          </CatalogCardWrapper>
        )}

        <CustomModal
          visible={configModal}
          onCancelModal={() => setConfigModal(false)}
          footer={[
            <Row justify="end">
              <Col span={24} style={{ width: "100%" }}>
                <Button
                  style={{
                    backgroundColor: "#EEEEEE",
                    color: "#000000",
                    width: "30%",
                    border: "none",
                    letterSpacing: ".5px",
                    transition: ".2s ease-out(red)",
                    fontSize: "12px",
                  }}
                  onClick={() => setConfigModal(false)}
                >
                  CANCEL
                </Button>

                {!NewCatalogInput ? (
                  <Button
                    style={{
                      backgroundColor: "#ff9800 ",
                      color: "#fff",
                      width: "30%",
                      border: "none",
                      letterSpacing: ".5px",
                      transition: ".2s ease-out(red)",
                      fontSize: "12px",
                    }}
                    onClick={() => {
                      // const addtiveErrArr=[];   
                      const arr = [];

                      (product.rmx_product_additives || []).forEach((v, index) => {
                        console.log('PRODUCT_ADDTITIVE==>', v)
                        if (!v.price) {
                          arr[index] = 'error'
                        }

                      })
                      setAdditiveErr(arr)
                      const errorCheck = arr.some((item) => {
                        return item === "error"
                      })

                      if (product.price) {
                        if (errorCheck) {
                          return
                        }
                        updateProductPrice(
                          {
                            price: product.price,
                            rmx_product_additives: product.rmx_product_additives,
                          },
                          productId,
                          null,
                          () => {
                            setConfigModal(false);
                            callOnCallBack();
                          }
                        )
                      }
                      else {
                        setPriceError("Price is required.")
                      }
                    }
                    }
                  >
                    SAVE
                  </Button>
                ) : (
                  <Button
                    style={{
                      backgroundColor: "#ff9800 ",
                      color: "#fff",
                      width: "30%",
                      border: "none",
                      letterSpacing: ".5px",
                      transition: ".2s ease-out(red)",
                      fontSize: "12px",
                    }}
                    onClick={() => onAddProduct()}
                  >
                    SAVE
                  </Button>
                )}
              </Col>
            </Row>,
          ]
          }
        >
          <Row
            justify="space-between"
            style={{ marginBottom: "30px" }}
          >
            <Col span={12} xl={16}>
              <h5 className="text-left">{product?.name}</h5>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8} xl={8} style={{ float: 'left' }} >
              <span style={{ paddingRight: "5px", fontSize: "1.1rem" }}>$</span>
              <InputNumber
                min={1}
                onChange={(e) => {
                  updatePriceOfProd(e, currentIndex);
                  setPriceError(true)
                }}
                name="price"
                value={product?.price?.toString()}
                type="number"
              />
              <span style={{ paddingLeft: "5px", fontSize: "1.1rem", color: '#323761' }}>
                {`/${product?.unit}`}
              </span>
              <Row >
                <Col className="danger-color" style={{ paddingLeft: "5px", fontSize: '90%', marginTop: '5px' }}>
                  {priceError && priceError}
                </Col>
              </Row>
            </Col>

          </Row>
          <Row>
            <Col span={9}>
              <img
                src={product?.image?.medium}
                style={{ objectFit: "contain", width: "90%" }}
              />
            </Col>
            <Col
              span={14}
              style={{
                border: "1px solid #F0F0F0",
                padding: "0.5rem",
                height: "auto",
              }}
            >
              <Row>
                <Col span={12} style={{ position: "relative" }}>
                  <img
                    src={Configuration}
                    style={{
                      width: "100%",
                      position: "absolute",
                      backgroundRepeat: "no-repeat",
                      top: "-20px",
                    }}
                  />
                </Col>
                <Col
                  span={24}
                  style={{
                    height: "8rem",
                    overflowY: "auto",
                    overflowX: "hidden",
                    margin: "5px",
                  }}
                >
                  { }
                  {!NewCatalogInput
                    ? (product.rmx_product_additives || []).map(
                      (item, index) => {
                        return (
                          <Row
                            justify="space-between"
                            align="middle"
                            style={{ marginBottom: "5px" }}
                          >
                            <Col span={14}>{item.name}</Col>
                            <Col span={10} >
                              <InputNumber
                                min={1}
                                max={100000}
                                onChange={(e) => onUpdateRmxPrice(e, index)}
                                name="price"
                                value={item.price}
                                type="number"
                              />
                            </Col>
                            <Col span={24}>
                              <Row justify="start" >
                                <Col className="danger-color" style={{ fontSize: '0.75rem' }}>
                                  {additiveErr[index] == 'error' ? "Price is required" : ''}
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        );
                      }
                    )
                    : (product.product_additives || []).map((item, index) => {
                      return (
                        <Row
                          justify="space-between"
                          align="middle"
                          style={{ marginBottom: "5px" }}
                        >
                          <Col span={14}>
                            {product.additives[index]["name"]}
                          </Col>
                          <Col span={10} >
                            <InputNumber
                              min={1}
                              max={100000}
                              onChange={(e) =>
                                onChangeOnAdd(
                                  e,
                                  index,
                                  product.additives[index]["name"]
                                )
                              }
                              type="number"
                              name="price"
                              value={item.price}
                            />
                          </Col>
                          <Col span={24}>
                            <Row justify="start">
                              <Col className="danger-color" style={{ fontSize: '0.75rem' }}>
                                {additiveErr[index] == 'error' ? "Price is required" : ''}
                              </Col>
                            </Row>

                          </Col>
                        </Row>
                      );
                    })}
                </Col>
              </Row>
            </Col>
          </Row>
        </CustomModal >
        <CustomModal
          visible={isOpenModal}
          onCancelModal={() => setIsOpenModal(false)}
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    updateProduct(
                      {},
                      productId,
                      product.status === 1 ? "deactivate" : "activate",
                      () => {
                        callOnCallBack();
                        setIsOpenModal(false);
                      }
                    )
                  }
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() => setIsOpenModal(false)}
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <img src={Delete_order} />
            </Col>
            <Col span={12} style={{ textAlign: "center" }}>
              <span>
                {product.status === 1
                  ? "Are you sure you want to deactivate this product"
                  : "Are you sure you want to activate this product"}
              </span>
            </Col>
          </Row>
        </CustomModal>

        {
          productData.some((item) => item.id === productId) && !onAdd ? (
            <Row justify="end">
              {isProductLoading ? (
                <img src={LoaderGif} height={"60"} width={"60"} />
              ) : (
                <Col>
                  <Button
                    style={{
                      backgroundColor: "#ff9800",
                      color: "#fff",
                      marginTop: "20px",
                    }}
                    onClick={() =>
                      postProduct(productData, () => history.push("/catalog"))
                    }
                  >
                    ADD
                  </Button>
                </Col>
              )}
            </Row>
          ) : ''
        }
      </Col >
    </Row >
  );
}
export default CatalogCard;
